import { render, staticRenderFns } from "./hongtu.vue?vue&type=template&id=01fa1da2&scoped=true&"
import script from "./hongtu.vue?vue&type=script&lang=js&"
export * from "./hongtu.vue?vue&type=script&lang=js&"
import style0 from "./hongtu.vue?vue&type=style&index=0&id=01fa1da2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa1da2",
  null
  
)

export default component.exports